<template>
    <EditModal
        id="singpauseSchulen"
        title="SingPause - Schulen"
        size="xl"
        button-text="Speichern"
        :busy="busy"
        scrollable
        @ok="dataProvide"
    >
        <b-tabs pills card vertical>
            <template v-slot:tabs-start>
                <SchoolYearSwitcher class="mb-2" />
            </template>
            <b-tab title="OGS">
                <SingPauseSchulenOGS
                    :id="id"
                    :refresh="refresh"
                    :validation="validation"
                    @update="updateData('ogs', ...arguments)"
                    @updateMeta="updateData('meta', ...arguments)"
                />
            </b-tab>
            <b-tab title="Zugew. Singleiter" active
                ><SingPauseSchulenKlassen :id="id" :refresh="refresh"
            /></b-tab>
            <b-tab title="Schulpersonal">
                <SingPauseSchulenContacts :id="id" :refresh="refresh" />
            </b-tab>
        </b-tabs>
    </EditModal>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import EditModal from "@/components/EditModal/EditModal";
import Toaster from "@/mixins/Toaster/Toaster";
import SingPause from "@/mixins/SingPause/SingPause";
import SingPauseSchulenOGS from "@/components/SingPauseSchulen/SingPauseSchulenOGS";
import SingPauseSchulenKlassen from "@/components/SingPauseSchulen/SingPauseSchulenKlassen";
import SingPauseSchulenContacts from "@/components/SingPauseSchulen/SingPauseSchulenContacts";
import SchoolYearSwitcher from "@/components/SchoolYearSwitcher/SchoolYearSwitcher";

const SingPauseApi = ApiFactory.get("singpause");

export default {
    name: "SingPauseSchulenModal",
    components: {
        EditModal,
        SingPauseSchulenOGS,
        SingPauseSchulenKlassen,
        SingPauseSchulenContacts,
        SchoolYearSwitcher
    },
    mixins: [Toaster, SingPause],
    props: ["id"],
    data() {
        return {
            busy: false,
            refresh: true,
            ogs: [],
            meta: {},
            validation: null
        };
    },
    methods: {
        async dataProvide(evt) {
            evt.preventDefault();
            this.busy = true;
            const responseOGS = await SingPauseApi.putOGS(
                this.id,
                this.ogs,
                this.selectedSchoolYear
            );
            const responseMeta = await SingPauseApi.putMeta(
                this.id,
                "sp_since",
                this.meta
            );
            /*const responseContacts = await SingPauseApi.putContacts(
                this.id,
                this.contacts,
                this.selectedSchoolYear
            );*/
            if (responseOGS.ok && responseMeta.ok) {
                // this.dataCancel();
                // this.$root.$emit("bv::hide::modal", "singpauseMitglieder");
                this.makeToast(
                    "Erfolgreich gespeichert",
                    "Die Änderungen wurden erfolgreich in der Datenbank gespeichert"
                );
                this.refresh = !this.refresh;
                this.validation = null;
            } else if (!responseOGS.ok && responseOGS.json.validation) {
                this.validation = responseOGS.json.validation;
            }
            this.busy = false;
        },
        dataCancel() {
            this.ogs = [];
        },
        updateData(identifier, data) {
            this.validation = null;
            this[identifier] = data;
        }
    }
};
</script>
